<section class="h-100">
    <!-- <div class="header">
        <nav class="navbar navbar-light topbar fixed-top shadow-sm">
            <div class="container p-0">
                <a class="navbar-brand" routerLink="/">
                    <img alt="loading..." src="{{platform_logo}}" alt="{{platform_name}}" width="160" />
                </a>
                <div class="d-flex justify-align-center float-right">
                    <button routerLink="/login" class="btn btn-info btn-sm mr-2" type="button">
                        Join Now / Sign In
                    </button>
                </div>
            </div>
        </nav>
    </div> -->
    <app-outer-header-navigation></app-outer-header-navigation>

    <div class="page-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-12 col-sm-12">
                    <div class="card">
                        <div class="card-body p-2">
                            <div class="w-100 bg-white px-2">
                                <h1 class="card-title mb-0">
                                    <span class="lstick"></span>
                                    <a href="javascript:void(0);" routerLink="/news" style="font-size: 20px;">
                                        <span class="mdi mdi-arrow-left mdi-24px pos-rel-1"></span> Back
                                    </a>
                                </h1>
                            </div>
                        </div>
                    </div>
                    <div class="card" *ngIf="newsDetailsLoader">
                        <div class="card-body text-center">
                            <h5 class="mt-0 d-flex align-items-start w-75">
                                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                    <div class="background-masker btn-divide-left"></div>
                                </span>
                            </h5>
                            <h5 class="mt-0 d-flex align-items-start w-25">
                                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                    <div class="background-masker btn-divide-left"></div>
                                </span>
                            </h5>
                            <h5 class="mt-0 d-flex align-items-start w-50">
                                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                    <div class="background-masker btn-divide-left"></div>
                                </span>
                            </h5>
                            <h5 class="mt-0 d-flex align-items-start w-50">
                                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                    <div class="background-masker btn-divide-left"></div>
                                </span>
                            </h5>
                            <div class="animated-background first-loader-ad" style="height: 180px;">
                                <div class="background-masker btn-divide-left"></div>
                            </div>
                            <h5 class="mt-0 d-flex align-items-start my-4">
                                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                    <div class="background-masker btn-divide-left"></div>
                                </span>
                            </h5>
                            <h5 class="mt-0 d-flex align-items-start">
                                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                    <div class="background-masker btn-divide-left"></div>
                                </span>
                            </h5>
                            <h5 class="mt-0 d-flex align-items-start">
                                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                    <div class="background-masker btn-divide-left"></div>
                                </span>
                            </h5>
                            <h5 class="mt-0 d-flex align-items-start w-75">
                                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                    <div class="background-masker btn-divide-left"></div>
                                </span>
                            </h5>
                            <h5 class="mt-0 d-flex align-items-start my-4">
                                <span class="flex-fill animated-background-name first-loader-name-news ml-0 mr-4">
                                    <div class="background-masker btn-divide-left"></div>
                                </span>
                                <span class="shared-dom">
                                    <div class="sub-rect-news pure-background"></div>
                                </span>
                            </h5>

                        </div>

                    </div>
                    <div class="card" *ngIf="emptyNewsDetails">
                        <div class="card-body ">
                            <h4 class="m-2 text-center">No news details available here!</h4>
                        </div>
                    </div>
                    <div>
                        <div class="card blogHeading" *ngIf="!newsDetailsLoader && !emptyNewsDetails">
                            <div class="card-body">
                                <div class="w-100">
                                    <h1 class="card-title mb-0">{{newsDetailsArr.title}}</h1>
                                    <p class="mb-2 font-bold d-inline-block">
                                        <strong  >
                                            <span *ngIf="newsDetailsArr.sport_name == 'Cricket'" >
                                                League: {{newsDetailsArr.sport_name}}
                                            <img alt="loading..." alt="" class="img-fluid img-league-logo" src="assets/images/cricket_v1.png" width="50">
                                            </span>
                                            <span *ngIf="newsDetailsArr.sport_name != 'Cricket'">
                                                League: {{newsDetailsArr.news_league_shortName}}
                                            <img alt="loading..." alt="" class="img-fluid img-league-logo" src="{{newsDetailsArr.profile_pic}}" width="50">
                                            </span>
                                            
                                        </strong>
                                        
                                    </p>
                                    <br>
                                    <div>
                                        <div class="float-left">
                                            <p class="mb-2 font-bold d-inline-block">
                                                Posted on: {{newsDetailsArr.posted_time}}

                                            </p>

                                            <p class="card-title mb-2" *ngIf="newsDetailsArr && newsDetailsArr.credit != ''">
                                                Credit: {{newsDetailsArr.credit}}
                                            </p>
                                        </div>
                                        <div>
                                            <div class="float-right">
                                                <div class="btn-group" dropdown placement="bottom right">
                                                    <a href="javascript:void(0);" id="button-dropup" dropdownToggle class="share_hover dropdown-toggle" aria-controls="dropdown-basic" placement="top" ngbTooltip="Share">
                                                        <img alt="loading..."    src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                                                    </a>
                                                    <ul id="dropdown-dropup" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-dropup">
                                                        <li class="light-blue" role="menuitem">
                                                            <div (click)="postUrlCopy();">
                                                                <a class="dropdown-item" href="javascript:void(0);">Copy Link To News</a>
                                                                <a href="javascript:void(0);"><small class="d-block text-left mb-2">Click
                                                                        here to copy news link</small></a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="post-thumb mb-2">
                                        <div *ngIf="newsDetailsArr.urlToImage">
                                            <span *ngIf="newsDetailsArr.urlToImage">


                                                <app-progressive-image class="img-fluid">
                                                    <img alt="loading..." appProgressiveImage src="{{newsDetailsArr.urlToImage}}" class="img-fluid">

                                                    <div appProgressiveImagePlaceholder class="newsImgLoader">
                                                        <div id="loaderProgressive" class="centerProgressive"></div>
                                                    </div>
                                                    <img alt="loading..." appProgressiveImageFallback class="img-fluid" src="assets/images/news.png">
                                                </app-progressive-image>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="color-new" *ngIf="newsDetailsArr.description && newsDetailsArr.description != ''" [innerHTML]='newsDetailsArr.description'></div>
                                    <div class="color-new" *ngIf="newsDetailsArr.description == ''" [innerHTML]='newsDetailsArr.content'></div>
                                    <div class="float-right">
                                        <div class="btn-group mb-2" dropdown placement="bottom right">
                                            <!-- <a href="javascript:void(0);" class="share_hover" placement="top" ngbTooltip="Share" (click)="openModallogin(loginalert)">
                                                <img alt="loading..." src="{{share_icon}}" class="img-fluid" alt="..." width="32">
                                            </a> -->
                                            <a href="javascript:void(0);" id="button-dropup" dropdownToggle class="share_hover dropdown-toggle" aria-controls="dropdown-basic" placement="top" ngbTooltip="Share">
                                                <img alt="loading..."    src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                                            </a>
                                            <ul id="dropdown-dropup" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-dropup">
                                                <li class="light-blue" role="menuitem">
                                                    <div (click)="postUrlCopy();">
                                                        <a class="dropdown-item" href="javascript:void(0);">Copy Link To News</a>
                                                        <a href="javascript:void(0);"><small class="d-block text-left mb-2">Click
                                                                here to copy news link</small></a>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-lg-4 col-md-12 col-sm-12">
                    <div class="">
                        <div class="card">
                            <div class="card-header bg-dark-blue text-center rounded-top fs-14">
                                Breaking News
                            </div>
                            <div class="card-body" *ngIf="!mostViewNewsLoader">

                                <div class="comment-widgets mb-0">
                                    <ul class="list-unstyled seperater mb-0">
                                        <li class="text-info" *ngFor="let newsdetails of mostViewedNewsArr">
                                            <small>
                                                <span *ngIf="newsdetails.sport_name == 'Cricket'" >
                                                    <span class="label" [ngClass]="newsdetails.league_color ? newsdetails.league_color : 'default-badge'">{{newsdetails.sport_name}}
                                                    </span>
                                                </span>

                                                <span *ngIf="newsdetails.sport_name != 'Cricket'" >
                                                    <span class="label" [ngClass]="newsdetails.league_color ? newsdetails.league_color : 'default-badge'">{{newsdetails.news_league_shortName}}
                                                    </span>
                                                </span>
                                                
                                            </small>&nbsp;
                                            <a class="text-dark" href="{{newsdetails.url}}">{{newsdetails.title}}</a>

                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card-body" *ngIf="mostViewNewsLoader">
                                <h5 class="mt-0 d-flex align-items-start">
                                    <span class="shared-dom">
                                        <div class="sub-rect-news pure-background"></div>
                                    </span>
                                    <span class="flex-fill animated-background-name first-loader-name-news">
                                        <div class="background-masker btn-divide-left"></div>
                                    </span>
                                </h5>
                                <h5 class="mt-0 d-flex align-items-start">
                                    <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                        <div class="background-masker btn-divide-left"></div>
                                    </span>
                                </h5>
                                <h5 class="mt-0 d-flex align-items-start">
                                    <span class="flex-fill animated-background-name first-loader-name-news m-0">
                                        <div class="background-masker btn-divide-left"></div>
                                    </span>
                                </h5>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header bg-dark-blue text-center rounded-top fs-14">
                                Leagues
                            </div>
                            <div class="card-body" *ngIf="!leagueLoader">

                                <ul class="list-unstyled seperater mb-0">
                                    <li class="text-info" *ngFor="let leagues of leagueList">
                                        <a href="javascript:void(0);" (click)="filterByLeague(leagues)"> <img alt="loading..." alt="" class="img-fluid img-league-logo" src="{{ ( leagues.name == 'Cricket') ? 'assets/images/cricket_v1.png' :  leagues.profile_pic}}" width="50"></a>&nbsp;
                                        <a href="javascript:void(0);" (click)="filterByLeague(leagues)">{{leagues.name}}
                                            <strong *ngIf="leagues.news_count > 0" class='ml-1'>({{leagues.news_count}})</strong></a>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-body" *ngIf="leagueLoader">
                                <div *ngFor="let e of [].constructor(3);">
                                    <h5 class="mt-0 d-flex align-items-start mx-2">
                                        <span class="shared-dom">
                                            <div class="sub-rect-connection pure-background"></div>
                                        </span>
                                        <span class="flex-fill animated-background-name first-loader-name mt-2">
                                            <div class="background-masker btn-divide-left"></div>
                                        </span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>




    <ng-template #loginalert>
        <div class="modal-header border-0">
            <button type="button" class="close pull-right" aria-label="Close" (click)="this.modalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body text-center">
            <img alt="loading..." alt="Smile" class="img-fluid mb-2" src="assets/images/smile.png" width="45" />
            <p>Please create account or login to use this features.</p>
            <a class="btn btn-info btn-sm mr-2" href="javascript:void(0);" (click)="redirectToLogin();">Login</a>
            <a href="javascript:void(0);" (click)="redirectToLogin();" class="btn btn-success btn-sm">Sign
                Up</a>
        </div>
    </ng-template>
</section>